import { useEffect, useState } from 'react';
import './App.css';
import * as PANOLENS from "panolens";
import * as THREE from "three";

/* 1803Sシングル */
import Image1803_1 from "./panorama/1803-1.JPG"
import Image1803_2 from "./panorama/1803-2.JPG"

/* 1818 シングル */
import Image1818_1 from "./panorama/1818-1.JPG"
import Image1818_2 from "./panorama/1818-2.JPG"

/* 1820 ダブル */
import Image1820_1 from "./panorama/1820-1.JPG"
import Image1820_2 from "./panorama/1820-2.JPG"

/* 2003S　シングル */
import Image2003_1 from "./panorama/2003-1.JPG"
import Image2003_2 from "./panorama/2003-2.JPG"

/* 2005　シングル */
import Image2005_1 from "./panorama/2005-1.JPG"
import Image2005_2 from "./panorama/2005-2.JPG"


/* 2006　シングル */
import Image2006_1 from "./panorama/2006-1.JPG"
import Image2006_2 from "./panorama/2006-2.JPG"

/* 2020ダブル　シングル */
import Image2020_1 from "./panorama/2020-1.JPG"
import Image2020_2 from "./panorama/2020-2.JPG"

/* 朝食会場 */
import ImageBreak1 from "./panorama/break1.JPG"
import ImageBreak2 from "./panorama/break2.JPG"
import ImageBreak3 from "./panorama/break3.JPG"

/* その他 */
import ImageEntrance from "./panorama/entrance.JPG"//エントランス
import ImageLobby from "./panorama/lobby.JPG"//ロビー
import ImageOut from "./panorama/out.JPG"//外観
import ImageCoin from "./panorama/coin.JPG"//コインランドリー
import ImageJido from "./panorama/jido.JPG"//自動販売機
import ImageSmoke from "./panorama/smoke.JPG"//喫煙スペース
import Image8F from "./panorama/8F.JPG"
import Image10F from "./panorama/10F.JPG"


/* 移動ボタン */
import infoSpot from "./panorama/infoSpot.png"
import Map from './Map';
import Slide from './Slide';


function App() {
  const pictures =["/static/media/8F.820be8a6864ed8430bb6.JPG",
  "/static/media/10F.cd4364d0e046b04399e7.JPG",
  "/static/media/1803-1.1cb3fff8a05cbf75a7a8.JPG",
  "/static/media/1803-2.d8287c4844f80cfcb9fa.JPG",
  "/static/media/1818-1.d8e0db9f5fff13ecb1b7.JPG",
  "/static/media/1818-2.122b801d9c08cb7ff022.JPG",
  "/static/media/1820-1.8b38ab449229c43111a4.JPG",
  "/static/media/1820-2.569cdb72474217f83167.JPG",
  "/static/media/2003-1.8ec72eca9881b29b30cd.JPG",
  "/static/media/2003-2.cf8313bd3ffcca8358b2.JPG",
  "/static/media/2005-1.2a74d46fcb1db64a8452.JPG",
  "/static/media/2005-2.f2d0c94a61f0294b23a1.JPG",
  "/static/media/2006-1.95556de25f68d566c8f5.JPG",
  "/static/media/2006-2.73a6c0d8510745c2d764.JPG",
  "/static/media/2020-1.6b933dacc133fcec3869.JPG",
  "/static/media/2020-2.52ef0738e72a75de5115.JPG",
  "/static/media/break1.bc52bb20077f685510fb.JPG",
  "/static/media/break2.7657622a1e9da6656a5d.JPG",
  "/static/media/break3.31ed8b7e33c91b1ebfe9.JPG",
  "/static/media/coin.e2e0bba68bbd06510858.JPG",
  "/static/media/entrance.c8f98180a315c2683131.JPG",
  "/static/media/jido.4c485a3e6b5e155e9248.JPG",
  "/static/media/lobby.5287cf22ea10abb6a796.JPG",
  "/static/media/out.fe4e5430172092d27cc6.JPG",
  "/static/media/smoke.12bb7c2eadd4297f616b.JPG"
]

  useEffect(() => {
    pictures.forEach((picture) => {
      const img = new Image();
      img.src = picture;
      console.log(img)
    });
  },[])
    const [panorama1803_1] = useState(new PANOLENS.ImagePanorama( "/static/media/1803-1.1cb3fff8a05cbf75a7a8.JPG" ))
    const [panorama1803_2] = useState(new PANOLENS.ImagePanorama( "/static/media/1803-2.d8287c4844f80cfcb9fa.JPG" ))
    const [panorama1818_1] = useState(new PANOLENS.ImagePanorama( "/static/media/1818-1.d8e0db9f5fff13ecb1b7.JPG" ))
    const [panorama1818_2] = useState(new PANOLENS.ImagePanorama( "/static/media/1818-2.122b801d9c08cb7ff022.JPG" ))
    const [panorama1820_1] = useState(new PANOLENS.ImagePanorama( "/static/media/1820-1.8b38ab449229c43111a4.JPG" ))
    const [panorama1820_2] = useState(new PANOLENS.ImagePanorama( "/static/media/1820-2.569cdb72474217f83167.JPG" ))
    const [panorama2003_1] = useState(new PANOLENS.ImagePanorama( "/static/media/2003-1.8ec72eca9881b29b30cd.JPG" ))
    const [panorama2003_2] = useState(new PANOLENS.ImagePanorama( "/static/media/2003-2.cf8313bd3ffcca8358b2.JPG"))
    const [panorama2005_1] = useState(new PANOLENS.ImagePanorama( "/static/media/2005-1.2a74d46fcb1db64a8452.JPG"))
    const [panorama2005_2] = useState(new PANOLENS.ImagePanorama( "/static/media/2005-2.f2d0c94a61f0294b23a1.JPG" ))
    const [panorama2006_1] = useState(new PANOLENS.ImagePanorama( "/static/media/2006-1.95556de25f68d566c8f5.JPG" ))
    const [panorama2006_2] = useState(new PANOLENS.ImagePanorama( "/static/media/2006-2.73a6c0d8510745c2d764.JPG" ))
    const [panorama2020_1] = useState(new PANOLENS.ImagePanorama( "/static/media/2020-1.6b933dacc133fcec3869.JPG" ))
    const [panorama2020_2] = useState(new PANOLENS.ImagePanorama( "/static/media/2020-2.52ef0738e72a75de5115.JPG"))
    const [panoramaOut] = useState(new PANOLENS.ImagePanorama( "/static/media/out.fe4e5430172092d27cc6.JPG" ))
    const [panoramaCoin] = useState(new PANOLENS.ImagePanorama( "/static/media/coin.e2e0bba68bbd06510858.JPG" ))
    const [panoramaJido] = useState(new PANOLENS.ImagePanorama( "/static/media/jido.4c485a3e6b5e155e9248.JPG" ))
    const [panoramaSmoke] = useState(new PANOLENS.ImagePanorama( "/static/media/smoke.12bb7c2eadd4297f616b.JPG" ))
    const [panorama8F] = useState(new PANOLENS.ImagePanorama( "/static/media/8F.820be8a6864ed8430bb6.JPG" ))
    const [panorama10F] = useState(new PANOLENS.ImagePanorama( "/static/media/10F.cd4364d0e046b04399e7.JPG" ))
    const [panoramaEntrance] = useState(new PANOLENS.ImagePanorama( "/static/media/entrance.c8f98180a315c2683131.JPG" ))
    const [panoramaLobby] = useState(new PANOLENS.ImagePanorama( "/static/media/lobby.5287cf22ea10abb6a796.JPG" ))
    const [panoramaB1] = useState(new PANOLENS.ImagePanorama( "/static/media/break1.bc52bb20077f685510fb.JPG" ))
    const [panoramaB2] = useState(new PANOLENS.ImagePanorama( "/static/media/break2.7657622a1e9da6656a5d.JPG" ))
    const [panoramaB3] = useState(new PANOLENS.ImagePanorama( "/static/media/break3.31ed8b7e33c91b1ebfe9.JPG" ))


    /* 現在のマップ内での位置 */
    const [position, setPosition] = useState(1)
    /* 現在のパノラマの番号 */
    const [current, setCurrent] = useState("1803")
    

    useEffect(() => {
      var infospot1803_1_2, infospot1803_2_1, infospot1818_1_2, infospot1818_2_1, infospot1820_1_2, infospot1820_2_1,
      infospot2003_1_2, infospot2003_2_1, infospot2005_1_2, infospot2005_2_1, infospot2006_1_2, infospot2006_2_1, infospot2020_1_2, infospot2020_2_1,
      infospotB_1_2, infospotB_1_3, infospotB_2_1, infospotB_2_3, infospotB_3_1, infospotB_3_2
      var container

    var lookAtPositions = [
      new THREE.Vector3(400, 0, 0),
      new THREE.Vector3(-50, 0, 0)
    ];

    container = document.querySelector( '#paranoma' );

    /* --------------パノラマ画像の読み込み -----------------*/

    /* 1803Sシングル */
    
    panorama1803_1.addEventListener( 'enter-fade-start', function(){
      console.log("1803_1")
      setPosition(1)
    } );

    panorama1803_2.addEventListener( 'enter-fade-start', function(){
      console.log("1803_2")
      setPosition(2)
    });


    /* インフォスポット */
    infospot1803_1_2 = new PANOLENS.Infospot( 200, infoSpot );
    infospot1803_1_2.position.set(3500, 0, -500 );
    infospot1803_1_2.addEventListener( 'click', function(){
      console.log(infospot1803_1_2.position)
      panorama1803_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama1803_2 } );
    } );
    panorama1803_1.add( infospot1803_1_2);

    infospot1803_2_1 = new PANOLENS.Infospot( 200, infoSpot );
    infospot1803_2_1.position.set(-3500, 0, 1000 );
    infospot1803_2_1.addEventListener( 'click', function(){
      console.log(infospot1803_2_1.position)
      panorama1803_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama1803_1 } );
    } );
    panorama1803_2.add( infospot1803_2_1);




    /* 1818 シングル */
    panorama1818_1.addEventListener( 'enter-fade-start', function(){
      console.log("1818_1")
      setPosition(1)
    } );

    panorama1818_2.addEventListener( 'enter-fade-start', function(){
      console.log("1818_2")
      setPosition(2)
    });


    /* インフォスポット */
    infospot1818_1_2 = new PANOLENS.Infospot( 200, infoSpot );
    infospot1818_1_2.position.set(-3500, 0, 500 );
    infospot1818_1_2.addEventListener( 'click', function(){
      console.log(infospot1818_1_2.position)
      
      panorama1818_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama1818_2 } );
    } );
    panorama1818_1.add( infospot1818_1_2);

    infospot1818_2_1 = new PANOLENS.Infospot( 200, infoSpot );
    infospot1818_2_1.position.set(3500, 0, -500 );
    infospot1818_2_1.addEventListener( 'click', function(){
      console.log(infospot1818_2_1.position)
      
      panorama1818_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama1818_1 } );
    } );
    panorama1818_2.add( infospot1818_2_1);





    /* 1820 ダブル */
    panorama1820_1.addEventListener( 'enter-fade-start', function(){
      console.log("1820_1")
      setPosition(1)
    } );

    panorama1820_2.addEventListener( 'enter-fade-start', function(){
      console.log("1820_2")
      setPosition(2)
    });


    /* インフォスポット */
    infospot1820_1_2 = new PANOLENS.Infospot( 200, infoSpot );
    infospot1820_1_2.position.set(-3500, 0, 500 );
    infospot1820_1_2.addEventListener( 'click', function(){
      console.log(infospot1820_1_2.position)
      
      panorama1820_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama1820_2 } );
    } );
    panorama1820_1.add( infospot1820_1_2);

    infospot1820_2_1 = new PANOLENS.Infospot( 200, infoSpot );
    infospot1820_2_1.position.set(3500, 0, -500 );
    infospot1820_2_1.addEventListener( 'click', function(){
      console.log(infospot1820_2_1.position)
      
      panorama1820_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama1820_1 } );
    } );
    panorama1820_2.add( infospot1820_2_1);




    /* 2003S シングル */
    panorama2003_1.addEventListener( 'enter-fade-start', function(){
      console.log("2003_1")
      setPosition(1)
    } );

    panorama2003_2.addEventListener( 'enter-fade-start', function(){
      console.log("2003_2")
      setPosition(2)
    });


    /* インフォスポット */
    infospot2003_1_2 = new PANOLENS.Infospot( 200, infoSpot );
    infospot2003_1_2.position.set(3500, 0, -500 );
    infospot2003_1_2.addEventListener( 'click', function(){
      console.log(infospot2003_1_2.position)
      
      panorama2003_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2003_2 } );
    } );
    panorama2003_1.add( infospot2003_1_2);

    infospot2003_2_1 = new PANOLENS.Infospot( 200, infoSpot );
    infospot2003_2_1.position.set(-3500, 0, 2000 );
    infospot2003_2_1.addEventListener( 'click', function(){
      console.log(infospot2003_2_1.position)
      
      panorama2003_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2003_1 } );
    } );
    panorama2003_2.add( infospot2003_2_1);






    /* 2005 シングル */
    panorama2005_1.addEventListener( 'enter-fade-start', function(){
      console.log("2005_1")
      setPosition(1)
    } );

    panorama2005_2.addEventListener( 'enter-fade-start', function(){
      console.log("2005_2")
      setPosition(5)
    });


    /* インフォスポット */
    infospot2005_1_2 = new PANOLENS.Infospot( 200, infoSpot );
    infospot2005_1_2.position.set(3500, 0, 0 );
    infospot2005_1_2.addEventListener( 'click', function(){
      console.log(infospot2005_1_2.position)
      
      panorama2005_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2005_2 } );
    } );
    panorama2005_1.add( infospot2005_1_2);

    infospot2005_2_1 = new PANOLENS.Infospot( 200, infoSpot );
    infospot2005_2_1.position.set(-3500, 0, 200 );
    infospot2005_2_1.addEventListener( 'click', function(){
      console.log(infospot2005_2_1.position)
      
      panorama2005_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2005_1 } );
    } );
    panorama2005_2.add( infospot2005_2_1);




    /* 2006 ツイン */
    panorama2006_1.addEventListener( 'enter-fade-start', function(){
      console.log("2006_1")
      setPosition(1)
    } );

    panorama2006_2.addEventListener( 'enter-fade-start', function(){
      console.log("2006_2")
      setPosition(2)
    });


    /* インフォスポット */
    infospot2006_1_2 = new PANOLENS.Infospot( 200, infoSpot );
    infospot2006_1_2.position.set(3500, 0, -2000 );
    infospot2006_1_2.addEventListener( 'click', function(){
      console.log(infospot2006_1_2.position)
      
      panorama2006_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2006_2 } );
    } );
    panorama2006_1.add( infospot2006_1_2);

    infospot2006_2_1 = new PANOLENS.Infospot( 200, infoSpot );
    infospot2006_2_1.position.set(-3500, 0, 3000 );
    infospot2006_2_1.addEventListener( 'click', function(){
      console.log(infospot2006_2_1.position)
      
      panorama2006_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2006_1 } );
    } );
    panorama2006_2.add( infospot2006_2_1);





    /* 2020 ダブル */
    panorama2020_1.addEventListener( 'enter-fade-start', function(){
      console.log("2020_1")
      setPosition(1)
    } );

    panorama2020_2.addEventListener( 'enter-fade-start', function(){
      console.log("2020_2")
      setPosition(2)
    });


    /* インフォスポット */
    infospot2020_1_2 = new PANOLENS.Infospot( 200, infoSpot );
    infospot2020_1_2.position.set(-3500, 0, -1500 );
    infospot2020_1_2.addEventListener( 'click', function(){
      console.log(infospot2020_1_2.position)
      
      panorama2020_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2020_2 } );
    } );
    panorama2020_1.add( infospot2020_1_2);

    infospot2020_2_1 = new PANOLENS.Infospot( 200, infoSpot );
    infospot2020_2_1.position.set(3500, 0, 3500 );
    infospot2020_2_1.addEventListener( 'click', function(){
      console.log(infospot2020_2_1.position)
      
      panorama2020_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2020_1 } );
    } );
    panorama2020_2.add( infospot2020_2_1);
    
    

    /*　朝食会場 */
    panoramaB1.addEventListener( 'enter-fade-start', function(){
      console.log("1803_1")
      setPosition(1)
    } );

    infospotB_1_2 = new PANOLENS.Infospot( 200, infoSpot );
    infospotB_1_2.position.set(-2000, 0, 5000 );
    infospotB_1_2.addEventListener( 'click', function(){
      console.log(infospotB_1_2.position)
      
      panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaB2 } );
    } );
    panoramaB1.add( infospotB_1_2);

    infospotB_1_3 = new PANOLENS.Infospot( 200, infoSpot );
    infospotB_1_3.position.set(-4000, 0, 2000 );
    infospotB_1_3.addEventListener( 'click', function(){
      console.log(infospotB_1_3.position)
      
      panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaB3 } );
    } );
    panoramaB1.add( infospotB_1_3);

    panoramaB2.addEventListener( 'enter-fade-start', function(){
      console.log("1803_2")
      setPosition(2)
    });

    infospotB_2_1 = new PANOLENS.Infospot( 200, infoSpot );
    infospotB_2_1.position.set(3000, 0, -5000 );
    infospotB_2_1.addEventListener( 'click', function(){
      console.log(infospotB_2_1.position)
      
      panoramaB2.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaB1 } );
    } );
    panoramaB2.add( infospotB_2_1);

    infospotB_2_3 = new PANOLENS.Infospot( 200, infoSpot );
    infospotB_2_3.position.set(-2000, 0, -4000 );
    infospotB_2_3.addEventListener( 'click', function(){
      console.log(infospotB_2_3.position)
      
      panoramaB2.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaB3 } );
    } );
    panoramaB2.add( infospotB_2_3);

    panoramaB3.addEventListener( 'enter-fade-start', function(){
      console.log("1803_2")
      setPosition(3)
    });

    infospotB_3_1 = new PANOLENS.Infospot( 200, infoSpot );
    infospotB_3_1.position.set(4000, 0, -1000 );
    infospotB_3_1.addEventListener( 'click', function(){
      console.log(infospotB_3_1.position)
      
      panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaB1 } );
    } );
    panoramaB3.add( infospotB_3_1);

    infospotB_3_2 = new PANOLENS.Infospot( 200, infoSpot );
    infospotB_3_2.position.set(2000, 0, 4000 );
    infospotB_3_2.addEventListener( 'click', function(){
      console.log(infospotB_3_2.position)
      
      panoramaB3.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaB2 } );
    } );
    panoramaB3.add( infospotB_3_2);


    /*　その他 */
    panoramaEntrance.addEventListener( 'enter-fade-start', function(){
      console.log("エントランス")
      setPosition(1)
    });
    panoramaLobby.addEventListener( 'enter-fade-start', function(){
      console.log("ロビー")
      setPosition(1)
    });
    panoramaOut.addEventListener( 'enter-fade-start', function(){
      console.log("外観")
      setPosition(1)
    });
    panoramaCoin.addEventListener( 'enter-fade-start', function(){
      console.log("コインランドリー")
      setPosition(1)
    });
    panoramaJido.addEventListener( 'enter-fade-start', function(){
      console.log("自販機")
      setPosition(1)
    });
    panoramaSmoke.addEventListener( 'enter-fade-start', function(){
      console.log("喫煙所")
      setPosition(1)
    });
    panorama8F.addEventListener( 'enter-fade-start', function(){
      console.log("8F廊下")
      setPosition(1)
    });
    panorama10F.addEventListener( 'enter-fade-start', function(){
      console.log("10F廊下")
      setPosition(1)
    });





    

    var viewer = new PANOLENS.Viewer( { output: 'console', container: container, controlBar:false} );
    viewer.add( panorama1803_1, panorama1803_2 , panorama1818_1, panorama1818_2,  panorama1820_1 , panorama1820_2, panorama2003_1, panorama2003_2,
      panorama2005_1, panorama2005_2, panorama2006_1, panorama2006_2, panorama2020_1, panorama2020_2, panoramaB1, panoramaB2, panoramaB3,
      panoramaEntrance, panoramaLobby, panoramaOut, panoramaCoin, panoramaJido,
      panoramaSmoke, panorama8F, panorama10F );
    viewer.tweenControlCenter( lookAtPositions[0], 0 );
  

    },[])

   
  const move1803S = () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama1803_1 } );
    setCurrent("1803")
    setPosition(1)
  }

  const move1818 = () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama1818_1 } );
    setCurrent("1818")
    setPosition(1)
  }
  
  const move1820 = () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama1820_1 } );
    setCurrent("1820")
    setPosition(1)
  }

  const move2003 = () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2003_1 } );
    setCurrent("2003")
    setPosition(1)
  }

  const move2005 = () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2005_1 } );
    setCurrent("2005")
    setPosition(1)
  }

  const move2006 = () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2006_1 } );
    setCurrent("2006")
    setPosition(1)
  }

  const move2020 = () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2020_1 } );
    setCurrent("2020")
    setPosition(1)
  }

  const moveBreak= () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaB1 } );
    setCurrent("Break")
    setPosition(1)
  }
  const moveEntrance= () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaEntrance } );
    setCurrent("Entrance")
    setPosition(1)
  }
  const moveLobby= () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaLobby } );
    setCurrent("Lobby")
    setPosition(1)
  }
  const moveOut= () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaOut } );
    setCurrent("Out")
    setPosition(1)
  }
  const moveCoin= () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaCoin } );
    setCurrent("Coin")
    setPosition(1)
  }
  const moveJido= () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaJido } );
    setCurrent("Jido")
    setPosition(1)
  }
  const moveSmoke= () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaSmoke } );
    setCurrent("Smoke")
    setPosition(1)
  }
  const move8F= () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama8F } );
    setCurrent("8F")
    setPosition(1)
  }
  const move10F= () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama10F } );
    setCurrent("10F")
    setPosition(1)
  }


  /*---------- マップ関数 ------------*/

  /* 1803Sシングル */
  const move1803_1 = () => {
    panorama1803_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama1803_1 } )
  }
  const move1803_2 = () => {
    panorama1803_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama1803_2 } )
  }

  /* 1818 */
  const move1818_1 = () => {
    panorama1818_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama1818_1 } )
  }
  const move1818_2 = () => {
    panorama1818_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama1818_2 } )
  }

  /* 1820 */
  const move1820_1 = () => {
    panorama1820_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama1820_1 } )
  }
  const move1820_2 = () => {
    panorama1820_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama1820_2 } )
  }

  /* 2003 */
  const move2003_1 = () => {
    panorama2003_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2003_1 } )
  }
  const move2003_2 = () => {
    panorama2003_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2003_2 } )
  }

  /* 2005 */
  const move2005_1 = () => {
    panorama2005_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2005_1 } )
  }
  const move2005_2 = () => {
    panorama2005_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2005_2 } )
  }

  /* 2006 */
  const move2006_1 = () => {
    panorama2005_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2006_1 } )
  }
  const move2006_2 = () => {
    panorama2005_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2006_2 } )
  }

  /* 2020 */
  const move2020_1 = () => {
    panorama2020_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2020_1 } )
  }
  const move2020_2 = () => {
    panorama2020_1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panorama2020_2 } )
  }

  /* 朝食会場 */
  const moveB_1 = () => {
    panoramaB1.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaB1} )
  }
  const moveB_2 = () => {
    panoramaB2.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaB2} )
  }
  const moveB_3 = () => {
    panoramaB3.dispatchEvent( { type: 'panolens-viewer-handler', method: 'setPanorama', data: panoramaB3} )
  }

  return (
    <div className="App">
      <div id="panorama"></div>
      <Map current={current} position={position} move1803_1={move1803_1} move1803_2={move1803_2} move1818_1={move1818_1} move1818_2={move1818_2}
      move1820_1={move1820_1} move1820_2={move1820_2} move2003_1={move2003_1} move2003_2={move2003_2} move2005_1={move2005_1} move2005_2={move2005_2}
      move2006_1={move2006_1} move2006_2={move2006_2} move2020_1={move2020_1} move2020_2={move2020_2} moveB_1={moveB_1} moveB_2={moveB_2} moveB_3={moveB_3}
      />
      <Slide current={current} move1803S={move1803S} move1818={move1818} move1820={move1820} move2003={move2003} move2005={move2005}
      move2006={move2006} move2020={move2020} moveBreak={moveBreak} moveCoin={moveCoin} moveEntrance={moveEntrance} 
      moveJido={moveJido} moveLobby={moveLobby} moveOut={moveOut} moveSmoke={moveSmoke} move8F={move8F} move10F={move10F}
      />
      
    </div>
  );
}

export default App;